
import VideoPlayer from '~/components/VideoPlayer/videojs.vue'
import { mapGetters } from 'vuex'
import { Currency } from '~/plugins/Currency'
import Purchase from '../PurchaseAction/Purchase.vue'
import InnerLoading from '~/components/Shared/Loading/InnerLoading.vue'
import ProductSubscriptionButton from '../ProductSubscription/ProductSubscriptionButton.vue'
export default {
  props: {
    product: {
      default: () => {
        return {
          imagePath: '',
        }
      },
    },
    canUserBuyWithSubscription: {
      type: Boolean,
      default: false,
    },
    subscriptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showYoutube: '',
      showPayments: false,
      intrvl: -1,
      remain: {
        day: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
      },
      videoOptions: {
        live: false,
        autoplay: this.modal,
        controls: true,
        playbackRates: [0.5, 1, 1.5, 2],
        sources: [
          {
            src: this.$api.path(this.product.videoPath),
            type: 'video/mp4',
          },
        ],
      },
    }
  },
  computed: {
    ...mapGetters({
      getUserIP: 'user/getUserIP',
      getActiveUser: 'user/getActiveUser',
    }),
    noVideo() {
      return this.product.videoPath.includes('default')
    },
  },
  methods: {
    formatter(date) {
      return this.$date.format(date)
    },
    Currency(p) {
      return Currency(p, this.getUserIP.currency)
    },
    FILL_ZERO(time) {
      if (time < 10) return `0${time}`
      else return time
    },
    padTo2Digits(num) {
      return num.toString().padStart(2, '0')
    },
    formatDate(date) {
      return (
        [
          date.getFullYear(),
          this.padTo2Digits(date.getMonth() + 1),
          this.padTo2Digits(date.getDate()),
        ].join('-') +
        ' ' +
        [
          this.padTo2Digits(date.getHours()),
          this.padTo2Digits(date.getMinutes()),
          this.padTo2Digits(date.getSeconds()),
        ].join(':')
      )
    },
    SET_INTERVAL() {
      if (this.product.eventItems.length === 0) return
      const seconds = 1000
      const minutes = seconds * 60
      const hours = minutes * 60
      const days = hours * 24
      const event = this.product.eventItems[0]
      const vm = this
      this.intrvl = setInterval(
        () => this.EVENT_TIMES(seconds, minutes, hours, days, event, vm),
        1000
      )
    },
    EVENT_TIMES(seconds, minutes, hours, days, event, vm) {
      const d = new Date().getTime()
      const ed = this.$date.getTimeWithoutOffset(event.date)
      const remain = ed - d
      if (remain < 0) {
        vm.$store.commit('productDetail/SET_REMOVE_EVENT_ITEM', {
          index: 0,
          id: vm.product.id,
        })
        clearInterval(vm.intrvl)
        vm.SET_INTERVAL()
      }
      ;(vm.remain.day = Math.floor(remain / days)),
        (vm.remain.hours = Math.floor((remain % days) / hours)),
        (vm.remain.minutes = Math.floor((remain % hours) / minutes)),
        (vm.remain.seconds = Math.floor((remain % minutes) / seconds))
    },
    SET_SOURCE() {
      if (this.product.videoPath.includes('www.youtube.com/watch?v=')) {
        this.showYoutube = this.product.videoPath.split(
          'www.youtube.com/watch?v='
        )[1]
      }
    },
  },
  components: {
    VideoPlayer,
    Purchase,
    InnerLoading,
    ProductSubscriptionButton,
  },
  mounted() {
    this.SET_INTERVAL(true)
    this.SET_SOURCE()
  },
}
